<template>
    <div style="overflow: hidden;">
        <div class="row">
            <div class="col-md-6 p-0">      
                <div class="login-container">
                    <div class="login-background" :style="{'background-image': 'url(' + require('@/assets/img/login-bg-blue2.png') + ')'}">
                        <div class="login-form">
                            <div class="text-center mb-0">
                                <img src="@/assets/img/logo-pertamina-retail.png" width="250"/>
                            </div>
                            <h4 class="text-center">Login</h4>
                            <p class="text-center" style="font-size:12px;">
                                Welcome to Pertamina Retail Dashboard! Kindly provide your username and password to get started.
                            </p>
                            <form @submit.prevent="handleSubmit">
                                <div class="form-group">
                                <label for="username">Username</label>
                                <div class="input-container">
                                    <i class="fa fa-user"></i>
                                    <input
                                    type="text"
                                    id="username"
                                    v-model="username"
                                    maxlength="50"
                                    placeholder="Enter username"
                                    class="login-input"
                                    required
                                    />
                                </div>
                                </div>

                                <div class="form-group">
                                <label for="password">Password</label>
                                <div class="input-container">
                                    <i class="fa fa-lock"></i>
                                    <input
                                    :type="passwordType"
                                    id="password"
                                    v-model="password"
                                    maxlength="100"
                                    placeholder="Enter password"
                                    class="login-input"
                                    required
                                    />
                                    <button
                                    type="button"
                                    @click="togglePasswordVisibility"
                                    class="toggle-password"
                                    v-if="false"
                                    >
                                    <i :class="passwordType === 'password' ? 'fa fa-eye' : 'fa fa-eye-slash'"></i>
                                    </button>
                                </div>
                                </div>

                                <button type="submit" class="login-button">Login</button>
                                <br>
                                <br>
                            </form>
                        </div>
                    </div>
                </div>
            </div>
            <div class="col-md-6 right-container">
                <div class="right-text-header">
                    <h5>Dashboard Pertamina Retail</h5>
                    <h6>Assessing Performance and Growth</h6>
                    <p>This data provides insights into sales trends and customer preferences.</p>
                </div>
                <div class="right-image-container text-center">
                    <img src="@/assets/img/container-bg.png" style="width: 60%;" />
                </div>
                <div class="right-text-footer">
                    It enables more strategic decision-making for sales enhancement. Serves as a foundation for developing more effective and responsive strategies.
                </div>
               
            </div>
        </div>
    </div>
</template>

<script>
//import Bright from '@/components/page/Bright.js'
import {Config,AxiosWithJar} from '@/utility.js'

export default{
	//extends: Bright,
	components:{
		//ListItem,      
	},
    mounted() {
		//this.hideNonChildren();
        this.isLoggedIn();
    },
	data() {
		return {
			isChildRoute: false,
			url: '',
            
            username: '',
            password: '',
            passwordType: 'password',
            //isLoggedIn: false,

		}
	},
	watch:{
		$route(to, from) {
            //this.hideNonChildren();
        }
	},
	computed: {
		currentRouteName() {
			return ''; //this.getUri()
		}
	},
    methods:{
		hideNonChildren() {
            this.isChildRoute = this.$route.path !== '/bright';
        },

        handleSubmit() {
            this.login(this.username, this.password);
        },
        togglePasswordVisibility() {
            this.passwordType = this.passwordType === 'password' ? 'text' : 'password';
        },
        isLoggedIn() {
            if(localStorage.getItem('username') && localStorage.getItem('token')) {
                //this.isLoggedIn = true;

                //redirect to main page
                this.gotoMainPage();
            }
        },
        async login(username,password) {
			// alert(username+""+token);
			let options = { 
				mode:'cors',
				headers: { 
					// 'Content-Type': 'application/json',
					'Content-Type': 'application/x-www-form-urlencoded',
				},
				withCredentials: true
			}
		
			var data = ""
			// data={username:username,token:token}
			data = "username="+username+"&password="+password
            //console.log('data: ' + data);
			await AxiosWithJar().post(Config().apiURL+"/log/login",data,options).then((result)=> {
				if(result.data) {
                    let data = result.data;
                    let code = data.code;
                    console.log('code: ' + code);
					//this.isLogin=true
					//this.$store.commit('updateLoginInfo',result.data)
					//console.log(this.$store.getters.getLoginInfo)

                    if(code == 200) {
                        let token = data.token.token;
                        this.$store.commit('updateLoginInfo', data)
                        //console.log('token: ' + token);

                        localStorage.setItem("username",username);
                        localStorage.setItem("token",token);

                        this.gotoMainPage();

                    } else {
                        alert('invalid username & password');
                    }
				} else {
					//this.loginSSO()
				}
				//return result.data ? result.data.loggedin : 0
			})
            .catch(error=>{console.log('error: '+error)})
		},
        gotoMainPage() {
            //this.$router.push('/');
            window.location.href = '/';
        }

	},

}

</script>



<style>
.login-container {
  display: flex;
  justify-content: center;
  align-items: center;
  height: 100vh;
  background-color: #ffffff; /**f4f4f4 */

  background-repeat: no-repeat;
  background-size: cover;
  background-position: center;
}

.login-background {
  display: flex;
  justify-content: center;
  align-items: center;
  width: 700px;
  height: 650px;
  background-repeat: no-repeat;
  background-size: contain;
  background-position: center;
  position: relative; 
}

.login-form {
  background-color: white;
  padding: 20px;
  border-radius: 8px;
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1);
  width: 100%;
  max-height: 480px;
  max-width: 340px; 

  position: absolute; /* Agar bisa diposisikan relatif terhadap .login-background */
  bottom: 24px; /* Menjaga jarak dari bagian bawah */
  left: 50%; /* Mengatur posisi form ke tengah horizontal */
  transform: translateX(-50%); /* Memastikan form berada tepat di tengah */
}

.login-form h2 {
  text-align: center;
  margin-bottom: 20px;
}

.form-group {
  margin-bottom: 15px;
}

.form-group label {
  display: block;
  font-weight: bold;
}

.form-group input {
  width: 100%;
  padding: 10px;
  margin-top: 5px;
  border: 1px solid #ddd;
  border-radius: 4px;
}

.login-button {
  width: 100%;
  padding: 10px;
  background-color: #007bff;
  color: white;
  border: none;
  border-radius: 4px;
  cursor: pointer;
  transition: background-color 0.3s ease, box-shadow 0.3s ease; 
}

.login-button:hover {
  background-color: #0056b3;
}

.login-input {
  width: 100%;
  padding: 2px;
  font-size: 14px;
  border: 1px solid #ccc; /* Border default */
  border-radius: 5px;
  font-size: 16px;
  outline: none; /* Menghilangkan outline default pada input */
  transition: border-color 0.3s ease, box-shadow 0.3s ease; /* Transisi pada border-color dan box-shadow */
}

/* Gaya saat input dalam keadaan focus */
.login-input:focus {
  border-color: #007bff; /* Ubah border menjadi warna hijau saat focus */
  /*box-shadow: 0 0 8px #005BBDFF; */ /* Tambahkan shadow hijau */
}

.right-container-old {
    display: flex;
    justify-content: center;
    align-items: center;
    height: 100vh;
    /*background-color: #007bff; */
    background: linear-gradient(to right, #0E76E6FF, #007bff, #00aaff);
}

.right-container {
    display: flex;
    flex-direction: column; /* Mengatur elemen dalam kolom */
    justify-content: center;
    align-items: center;
    height: 100vh;
    background: linear-gradient(to right, #0E76E6FF, #007bff, #00aaff);
}

.right-text-header {
    color:white;
    font-size: 24px; /* Ukuran teks header */
    margin-bottom: 20px; /* Jarak antara header dan gambar */
    width:80%;
}

.right-text-header h5, .right-text-header h6 {
    color:white;
} 

.right-image-container img {
    max-width: 100%; /* Agar gambar responsif */
    height: auto; /* Mempertahankan rasio aspek gambar */
}

.right-text-footer {
    color: white;
    width:80%;
    font-size: 14px; /* Ukuran teks footer */
    margin-top: 20px; /* Jarak antara gambar dan footer */
}
</style>